import { Button, Input, Select, Table } from 'antd';
import { Option } from 'antd/es/mentions';
import React, { useState ,useEffect } from 'react'
import "../../MainCSS.css";
import "aos/dist/aos.css";
import axios from 'axios';
import {  DieNameMasterGet, DieCategoryMasterGet, DieNameMasterDelete, DieNameMasterSave, DieNameMasterUpdate, DieSubCategoryMasterByCategoryId, DieSubCategoryMasterGet, } from '../../../AllAPI/MasterAPI/DiesMasterApi';
import { toast } from 'react-toastify';
import { GetCustomerMaster } from '../../../AllAPI/MasterAPI/SalesMasterApi';
import { GetHSNCodeMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi';

const DieNameMaster = () => {

  const userData = sessionStorage.getItem('authToken');
  const userId = sessionStorage.getItem('userId');
  const authHeaders = sessionStorage.getItem('authHeaders');
  const headersObj = JSON.parse(authHeaders).headers;

  
  const userIp = headersObj.userIp
  const deviceSign = headersObj.deviceSign
  const userLong = headersObj.userLong
  const userLat = headersObj.userLat

  const commonHeaders = {
    headers: {
      createdBy: userId,
      updatedBy: userId,
      userIp: userIp,
      userLat: userLat,
      userLong: userLong,
      deviceSign: deviceSign,
    },
  };



   const [errors, setErrors] = useState({
        dieCategory: "",
        description: "",
    subDieCategory:"",
    hsnCode:"",
    dieName:"",
    diaNumber:"",
    customerName:"",
    dieType:"",
    // drawingAttach:"",
    customerMade:"",
    costCollect:"",
    costRefund:"",
    remarks:"",
    diePremium:"",

      });
    
      const [pageSize, setPageSize] = useState(10);
      const [filteredData, setFilteredData] = useState([]);
      const [currentPage, setCurrentPage] = useState(1);
      const [totalEntries, setTotalEntries] = useState(0);
    
      const [dieNameMasterId, setDieNameMasterId] = useState("");
      const [dieCategory, setDieCategory] = useState("");
      const [description, setDescription] = useState("");
      const [subDieCategory, setSubDieCategory] = useState("");
      const [allSubDieCategory, setAllSubDieCategory] = useState([]);
      const [allDieCategory, setAllDieCategory] = useState([]);
      const [allDieNameMaster, setAllDieNameMaster] = useState([]);
      const [allCustomer, setAllCustomer] = useState([]);
      const [allHSN, setAllHSN] = useState([]);
      const[dieName , setDieName]=useState("");
      const[diaNumber , setDiaNumber]=useState("");
      const[dieType,setDieType]=useState("");
      const[customerMade,setCustomerMade]=useState("");
      const[drawingAttach,setDrawingAttach]=useState("");
      const[customerName,setCustomerName]=useState("");
      const[costCollect,setCostCollect] = useState("");
      const[costRefund ,setCostRefund]=useState("");
      const[remarks , setRemarks] = useState("");
      const[hsnCode ,setHSNCode]= useState("");
      const[diePremium ,setDiePremium]=useState("");
      const [submitButton, setSubmitButton] = useState(true);
      const [updateButton, setUpdateButton] = useState(false);
       const [diaNameEntry, setDiaNameEntry] = useState(false);
      
        const [showTable, setShowTable] = useState(true)
      
        const handleShowForm = () => {
          setShowTable(false)
          setDiaNameEntry(true)
        }
        const diaNumberOptions = [
          { value: '1', label: '5' },
          { value: '2', label: '7' },
           { value: '3', label: '5,7' },
        ]
    
      //======Search data from table===============
      const handleSearch = (value) => {
        const searchValue = value.toLowerCase();
      
        const filtered = allDieNameMaster.filter((item) =>
          Object.values(item).some((val) =>
            String(val ?? "").toLowerCase().includes(searchValue)
          )
        );
      
        setFilteredData(filtered);
        setTotalEntries(filtered.length);
        setCurrentPage(1);
      };
      
      //==========Pagination=======================
      const handlePageSizeChange = (value) => {
        setPageSize(value);
      };
       // ==============Get table data================
      let isSubDieNameMasterMasterFetched = false;
      useEffect(() => {
        if (isSubDieNameMasterMasterFetched) return;
            fetchCustomerMaster();
            fetchDieCategoryMaster();
            fetchDieNameMaster();
            fetchHSNCodeMaster();

        isSubDieNameMasterMasterFetched = true;
      }, []);
    
      let isError = false;
    
      const fetchSubDieCategoryMasterByCategory = async (categoryId)  => {
        try {
          const response = await axios.get(`${DieSubCategoryMasterByCategoryId}?dieCategoryId=${categoryId}`,commonHeaders);
          if (response.data !== null) {
            setAllSubDieCategory(response.data);
            
          }
        } catch (error) {
          if (!isError) {
            console.error("Error fetching Sub Die Category  data:", error);
            toast.error("Failed to fetch Sub Die Category  data");
            isError = true; // Set the flag to prevent double toast
          }
        }
      };
      const fetchDieCategoryMaster = async () => {
       try {
         const response = await axios.get(DieCategoryMasterGet ,commonHeaders);
         if (response.data !== null) {
           setAllDieCategory(response.data);
          
         }
       } catch (error) {
         if (!isError) {
           console.error("Error fetching DieCategory  data:", error);
           toast.error("Failed to fetch DieCategory  data");
           isError = true; // Set the flag to prevent double toast
         }
       }
     };

     const fetchCustomerMaster = async () => {
      try {
        const response = await axios.get(GetCustomerMaster ,commonHeaders);
        if (response.data !== null) {
          setAllCustomer(response.data);
         
        }
      } catch (error) {
        if (!isError) {
          console.error("Error fetching Customer  data:", error);
          toast.error("Failed to fetch Customer  data");
          isError = true; // Set the flag to prevent double toast
        }
      }
    };
    const fetchHSNCodeMaster = async () => {
      try {
        const response = await axios.get(GetHSNCodeMaster ,commonHeaders);
        if (response.data !== null) {
          setAllHSN(response.data);
         
        }
      } catch (error) {
        if (!isError) {
          console.error("Error fetching HSN Code  data:", error);
          toast.error("Failed to fetch HSN Code  data");
          isError = true; // Set the flag to prevent double toast
        }
      }
    };
     const fetchDieNameMaster= async () => {
      try {
    
         const response = await axios.get(DieNameMasterGet,commonHeaders);
       if (response.data && response.data.length > 0) {
          setAllDieNameMaster(response.data);
          setFilteredData(response.data); // Set initial filtered data as the fetched data
          setTotalEntries(response.data.length); // Set the total number of entries
        }
        else{
          toast.warn("Data is not available !!");
          setAllDieNameMaster([]);
          setFilteredData([]);
          setTotalEntries([]);

        }
      } catch (error) {
        if (!isError) {
          console.error("Error fetching Die Name Master  data:", error);
          toast.error("Failed to fetch Die Name Master  data");
          isError = true; // Set the flag to prevent double toast
        }
      }
    };
    const handleDieCategoryChange =async (value) => {
      setDieCategory(value);
      if(value){
     await fetchSubDieCategoryMasterByCategory(value);
    }
      setSubDieCategory(""); 
    };
      // const columns = [
      //   {
      //     title: "Sr.No.",
      //     dataIndex: "",
      //     key: "index",
      //     render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
      //   },
       
      //   {
      //     title:" Die Name",
      //     dataIndex: "dieName",
      //     key: "dieName",
      //   },
      //   {
      //     title: "Dia Number",
      //     dataIndex: "diaNumber",
      //     key: "diaNumber",
      //     render: (value) => {
      //       const diaOption = diaNumberOptions.find(opt => opt.value === String(value));
      //       return diaOption ? diaOption.label : '';
      //     },
      //   },

      //   {
      //     title:" Category Name",
      //     dataIndex: "dieCategoryName",
      //     key: "dieCategoryName",
      //   },
      //   {
      //    title:" Sub Category Name",
      //    dataIndex: "dieSubCategoryName",
      //    key: "dieSubCategoryName",
      //  },
      //  {
      //   title:"Die Type",
      //   dataIndex: "typeofDie",
      //   key: "typeofDie",
      //   render: (dieType) => (dieType === 1 ? "Hollow" : "Solid"),
      // },
      //  {
      //     title:" Die Premium",
      //     dataIndex: "diePreminium",
      //     key: "diePreminium",
      //   },
      
      //   // {
      //   //   title:"File Attached",
      //   //   dataIndex: "attachedPDF",
      //   //   key: "attachedPDF",
      //   // },
      //   {
      //     title:"Cost Refund Criteria",
      //     dataIndex: "dieCostRefundCriteria",
      //     key: "dieCostRefundCriteria",
      //   },
      //   {
      //     title:"Cost Collected",
      //     dataIndex: "dieCostCollected",
      //     key: "dieCostCollected",
      //   },
      //   {
      //     title:"HSN Code",
      //     dataIndex: "hsnCode",
      //     key: "hsnCode",
      //   },
     
      //   {
      //     title:"Made for Customer",
      //     dataIndex: "whetherCustomerMade",
      //     key: "whetherCustomerMade",
      //     render: (customerMade) => (customerMade === 1 ? "Yes" : "No"),
      //   },
      //   {
      //     title:"Cusstomer Name",
      //     dataIndex: "customerName",
      //     key: "customerName",
          
      //   },
      
      //  {
      //     title: "Remarks",
      //     dataIndex: "remarks",
      //     key: "remarks",
      //   },
      //   {
      //     title: "Description",
      //     dataIndex: "description",
      //     key: "description",
      //   },
      //   {
      //     title: "Actions",
      //     key: "actions",
      //     render: (text, record) => (
      //       <div>
      //         <span
      //           type="submit"
      //           style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
      //           onClick={() => handleEditDataButton(record)}
      //         >
      //           <i class="fa-solid fa-pen-to-square"></i>
      //         </span>
      //         <span
      //           type="submit"
      //           style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
      //           onClick={() => handleDeleteData(record)}
      //         >
      //           <i class="fa-solid fa-trash"></i>
      //         </span>
      //       </div>
      //     ),
      //   },
      // ];
    
      const columns = [
  {
    title: "Sr.No.",
    dataIndex: "",
    key: "index",
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Die Name",
    dataIndex: "dieName",
    key: "dieName",
    sorter: (a, b) => a.dieName?.localeCompare(b.dieName),
  },
  {
    title: "Dia Number",
    dataIndex: "diaNumber",
    key: "diaNumber",
    render: (value) => {
      const diaOption = diaNumberOptions.find(opt => opt.value === String(value));
      return diaOption ? diaOption.label : '';
    },
    sorter: (a, b) => a.diaNumber - b.diaNumber,
  },
  {
    title: "Category Name",
    dataIndex: "dieCategoryName",
    key: "dieCategoryName",
    sorter: (a, b) => a.dieCategoryName?.localeCompare(b.dieCategoryName),
  },
  {
    title: "Sub Category Name",
    dataIndex: "dieSubCategoryName",
    key: "dieSubCategoryName",
    sorter: (a, b) => a.dieSubCategoryName?.localeCompare(b.dieSubCategoryName),
  },
  {
    title: "Die Type",
    dataIndex: "typeofDie",
    key: "typeofDie",
    render: (dieType) => (dieType === 1 ? "Hollow" : "Solid"),
    sorter: (a, b) => a.typeofDie - b.typeofDie,
  },
  {
    title: "Die Premium",
    dataIndex: "diePreminium",
    key: "diePreminium",
    sorter: (a, b) => parseFloat(a.diePreminium) - parseFloat(b.diePreminium),
  },
  {
    title: "Cost Refund Criteria",
    dataIndex: "dieCostRefundCriteria",
    key: "dieCostRefundCriteria",
    sorter: (a, b) => a.dieCostRefundCriteria?.localeCompare(b.dieCostRefundCriteria),
  },
  {
    title: "Cost Collected",
    dataIndex: "dieCostCollected",
    key: "dieCostCollected",
    sorter: (a, b) => parseFloat(a.dieCostCollected) - parseFloat(b.dieCostCollected),
  },
  {
    title: "HSN Code",
    dataIndex: "hsnCode",
    key: "hsnCode",
    sorter: (a, b) => a.hsnCode?.localeCompare(b.hsnCode),
  },
  {
    title: "Made for Customer",
    dataIndex: "whetherCustomerMade",
    key: "whetherCustomerMade",
    render: (value) => (value === 1 ? "Yes" : "No"),
    sorter: (a, b) => a.whetherCustomerMade - b.whetherCustomerMade,
  },
  {
    title: "Customer Name",
    dataIndex: "customerName",
    key: "customerName",
    sorter: (a, b) => a.customerName?.localeCompare(b.customerName),
  },
  {
    title: "Remarks",
    dataIndex: "remarks",
    key: "remarks",
    sorter: (a, b) => a.remarks?.localeCompare(b.remarks),
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    sorter: (a, b) => a.description?.localeCompare(b.description),
  },
  {
    title: "Actions",
    key: "actions",
    render: (text, record) => (
      <div>
        <span
          style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px", cursor: "pointer" }}
          onClick={() => handleEditDataButton(record)}
        >
          <i className="fa-solid fa-pen-to-square"></i>
        </span>
        <span
          style={{ fontSize: "12px", color: "red", marginLeft: "10px", cursor: "pointer" }}
          onClick={() => handleDeleteData(record)}
        >
          <i className="fa-solid fa-trash"></i>
        </span>
      </div>
    ),
  },
];

      const components = {
        header: {
          cell: ({ children, ...restProps }) => (
            <th
              {...restProps}
              style={{
                backgroundColor: "#023e7d",
                color: "#fff",
                padding: "10px",
                fontSize: "15px",
                borderRadius: "0px",
              }}
            >
              {children}
            </th>
          ),
        },
        body: {
          row: ({ children, ...restProps }) => (
            <tr
              {...restProps}
              style={{
                backgroundColor: "#f0f7fd",
              }}
            >
              {children}
            </tr>
          ),
          cell: ({ children, ...restProps }) => (
            <td
              {...restProps}
              style={{
                padding: "8px",
                 fontSize: "15px",
              }}
            >
              {children}
            </td>
          ),
        },
      };
         // ========Submit data to table==============
         const handleSubmit = async () => {
           let isValid = true;
           const errorObj = {};
           if (!dieName || (typeof dieName === 'string' && !dieName.trim())) {
            isValid = false;
            errorObj.dieName = "Die Name  is required *";
          }
          if (!diaNumber || (typeof diaNumber === 'string' && !diaNumber.trim())) {
            isValid = false;
            errorObj.diaNumber = "Dia Number  is required *";
          }
           if (!dieCategory || (typeof dieCategory === 'string' && !dieCategory.trim())) {
            isValid = false;
            errorObj.dieCategory = "Die Category Name is required *";
          }
           
           if(!subDieCategory|| (typeof subDieCategory === 'string' &&!subDieCategory.trim())) {
             isValid = false;
             errorObj.subDieCategory = " Sub Die Category Name is required *";
           }
             
           if(!customerName|| (typeof customerName === 'string' &&!customerName.trim())) {
             isValid = false;
             errorObj.customerName = " Customer Name is required *";
           }
           if(!customerMade|| (typeof customerMade === 'string' &&!customerMade.trim())) {
            isValid = false;
            errorObj.customerMade = " Customer Made is required *";
          }
          if(!dieType|| (typeof dieType === 'string' &&!dieType.trim())) {
            isValid = false;
            errorObj.dieType = " Die Type is required *";
          }
          // if(!drawingAttach|| (typeof drawingAttach === 'string' &&!drawingAttach.trim())) {
          //   isValid = false;
          //   errorObj.drawingAttach = " Attach Drawing is required *";
          // }
          if(!hsnCode|| (typeof hsnCode === 'string' &&!hsnCode.trim())) {
            isValid = false;
            errorObj.hsnCode = "HSN Code is required *";
          }
          
          if (!diePremium.trim()) {
            isValid = false;
            errorObj.diePremium = "Die Premium is required *";
          }

          if (!costCollect.trim()) {
            isValid = false;
            errorObj.costCollect = "Cost collection is required *";
          }
          
          if (!costRefund.trim()) {
            isValid = false;
            errorObj.costRefund = "Die cost refund criteria is required *";
          }
          
          if (!remarks.trim()) {
            isValid = false;
            errorObj.remarks = "Remarks is required *";
          }
          
          
           if (!description.trim()) {
             isValid = false;
             errorObj.description = "Description is required *";
           }

       
       
           setErrors(errorObj); // Set error messages
       
           if (!isValid) return;
       
  //           // Create a FormData object
  // const formData = new FormData();

  // // Append form data fields

  // formData.append('dieName', dieName);
  // formData.append('diaNumber', diaNumber);
  // formData.append('attachedPDF', drawingAttach); // Append the file (PDF)
  // formData.append('typeofDie', dieType);
  // formData.append('whetherCustomerMade', customerMade);
  // formData.append('customerId', customerName);
  // formData.append('dieCategoryId', dieCategory);
  // formData.append('description', description);
  // formData.append('dieSubCategoryId', subDieCategory);
  // formData.append('dieCostCollected', costCollect);
  // formData.append('dieCostRefundCriteria', costRefund);
  // formData.append('diePreminium', diePremium);
  // formData.append('hsnCodeId', hsnCode);
   
 
  // for (let [key, value] of formData.entries()) {
  //   // If the value is a file, log just the file name
  //   if (value instanceof File) {
  //     console.log(`${key}: ${value.name}`);
  //   } else {
  //     console.log(`${key}: ${value}`);
  //   }
  // }
  // console.log('Headers:', headers1);
  try {
    // //Send form data with axios
    // const response = await axios.post(DieNameMasterSave, formData,{
    //   headers: {
    //     ...headers1, // Keep other headers (e.g., Authorization) if needed
    //   },
    // } );
    
    const bodyData = {
   dieName: dieName,
  diaNumber: diaNumber,
  dieCategoryId: dieCategory,
dieSubCategoryId: subDieCategory,
  description: description,
  typeofDie: parseFloat(dieType),
  whetherCustomerMade: parseFloat(customerMade),
  customerId: customerName,
  dieCostCollected: costCollect,
  dieCostRefundCriteria: costRefund,
  remarks: remarks,
  diePreminium: diePremium,
  hsnCodeId: hsnCode,

   
    };

      const response = await axios.post(DieNameMasterSave, bodyData,commonHeaders)
    
             if (response.data === "CREATED") {
               toast.success(" Die Name  added successfully!");
               fetchDieNameMaster();
               handleCancel();
             } else if (response.data === "ALREADYEXISTED") {
               toast.warn("Die Name  already exist!");
               //handleCancel();
             }
           } catch (error) {
             console.error("Error during API call:", error);
             toast.error("Error occurred while submitting data");
           }
         };
     //==================== Handle Cancel button =====================
         const handleCancel = () => {
           setUpdateButton(false);
           setSubmitButton(true);
           setDescription("");
           setDieCategory("");
           setSubDieCategory("");
           setCostCollect("");
           setCostRefund("");
           setCustomerMade("");
           setCustomerName("");
           setDieName("");
           setDiaNumber("");
           setDiePremium("");
          //  setDrawingAttach("");
           setDieType("");
           setHSNCode("");
           setRemarks("");
           setErrors("");
           setShowTable(true)
           setDiaNameEntry(false)
           
         };
       // ========Update data from table============
       const handleEditDataButton = (item) => {
         setUpdateButton(true);
         setSubmitButton(false);
         window.scrollTo(0, 0);
         setDieCategory(item.dieCategoryId);
         setDescription(item.description);
         setSubDieCategory(item.dieSubCategoryId);

         setCostCollect(item.dieCostCollected);
         setCostRefund(item.dieCostRefundCriteria);
         setCustomerMade(item.whetherCustomerMade=== 1 ? "Yes" : "No");
         setCustomerName(item.customerId);
         setDieName(item.dieName);
         setDiaNumber(item.diaNumber?String(item.diaNumber):null);
         setDiePremium(item.diePreminium);
         setDieType(item.typeofDie=== 1 ? "Hollow" : "Solid");
        //  setDrawingAttach(item.attachedPDF);
         setHSNCode(item.hsnCodeId);
         setRemarks(item.remarks);
         setDieNameMasterId(item.id);
         fetchSubDieCategoryMasterByCategory(item.dieCategoryId);
         setShowTable(false)
         setDiaNameEntry(true)
       };
       const handleUpdate = async () => {
        if (!diaNumber) {
          toast.warn("Please select a Dia Number!");
          return;
        }
        if (!dieName) {
          toast.warn("Please enter a  Die Name!");
          return;
        }
         if (!dieCategory) {
           toast.warn("Please enter a Category!");
           return;
         }
         if (!subDieCategory) {
           toast.warn("Please enter a Sub Category!");
           return;
         }
         if (!description) {
           toast.warn("Please enter Description!");
           return;
         }
         if(!hsnCode){
          toast.warn("Please enter HSN code!");
          return;
         }
         if(!customerName) {
          toast.warn("Please enter Customer Name!");
          return;
        }
        if(!customerMade) {
          toast.warn("Please fill all details!");
          return;
       }
       if(!dieType) {
        toast.warn("Please enter type!");
        return;
       }
      //  if(!drawingAttach) {
      //   toast.warn("Please fill all details!");
      //   return;
      //  }
      
       
       if (!diePremium) {
        toast.warn("Please fill all details!");
        return;
       }
    
       if (!costCollect) {
        toast.warn("Please fill all details!");
        return;
       }
       
       if (!costRefund) {
        toast.warn("Please enter Cost Refund Criteria!");
        return;
       }
       
       if (!remarks) {
        toast.warn("Please enter Remarks!");
        return;
       }
     
        
          // Create a FormData object
//   const formData = new FormData();

//   // Append form data fields
//   formData.append('id', dieNameMasterId);
//   formData.append('dieName', dieName);
//   formData.append('diaNumber', diaNumber);
//   formData.append('attachedPDF', drawingAttach); // Append the file (PDF)
//   formData.append('typeofDie', dieType);
//   formData.append('whetherCustomerMade', customerMade);
//   formData.append('customerId', customerName);
//   formData.append('dieCategoryId', dieCategory);
//   formData.append('description', description);
//   formData.append('dieSubCategoryId', subDieCategory);
//   formData.append('dieCostCollected', costCollect);
//   formData.append('dieCostRefundCriteria', costRefund);
//   formData.append('remarks', remarks);
//   formData.append('diePreminium', diePremium);
//   formData.append('hsnCodeId', hsnCode);
// //  formData.append('createdBy',1);
//   for (let [key, value] of formData.entries()) {
//     // If the value is a file, log just the file name
//     if (value instanceof File) {
//       console.log(`${key}: ${value.name}`);
//     } else {
//       console.log(`${key}: ${value}`);
//     }
//   }
//   console.log(commonHeaders);
//   console.log(headers1);
  try {
    // Send form data with axios
    // const response = await axios.put(DieNameMasterUpdate, formData, {
    //   headers: commonHeaders, 
      
    // })
    const dieTypeValue = dieType === "Hollow" ? 1 : dieType === "Solid" ? 2 : 1;
    const customerMadeValue = customerMade === "Yes" ? 1 : customerMade === "No" ? 2 : 1;
    const bodyData = {
      id:dieNameMasterId,
      dieName: dieName,
     diaNumber: diaNumber,
     dieCategoryId: dieCategory,
   dieSubCategoryId:subDieCategory,
     description: description,
     typeofDie: parseFloat(dieTypeValue),
     whetherCustomerMade: parseFloat(customerMadeValue),
     customerId: customerName,
     dieCostCollected: costCollect,
     dieCostRefundCriteria: costRefund,
     remarks: remarks,
     diePreminium: diePremium,
     hsnCodeId: hsnCode,
   
      
       };
    const response = await axios.put(DieNameMasterUpdate, bodyData,commonHeaders)
           if (response.data === "UPDATED") {
             toast.success("Die Name  updated successfully!");
             fetchDieNameMaster();
             handleCancel();
           } else if (response.data === "ALREADYEXISTED") {
             toast.warn(" Die Name  already exist!");
             //handleCancel();
           }
         } catch (error) {
           console.error("Error during API call:", error);
           toast.error("Error occurred while updating data");
         }
       };
       //============================== Delete data from table ======================================
       const handleDeleteData = async (item) => {
         const confirmDelete = window.confirm(
           `Are you sure you want to delete the Die Name  "${item.dieName}"?`
         );
         if (!confirmDelete) return;
     
         try {
           const response = await axios.delete(
             `${DieNameMasterDelete}?id=${item.id}`,commonHeaders
           );
       
           if (response.data === "DELETED") {
             toast.success("Die Name deleted successfully!");
             fetchDieNameMaster();
             handleCancel();
           }
         } catch (error) {
           console.error("Error during delete operation:", error);
           toast.error("Error occurred while deleting ");
         }
       };
   
    return (
      <div className="px-5 py-3 " style={{ fontSize: "15px" }}> 
 <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
          
  <div className="col-12">


      <div className="p-0 m-0">
{diaNameEntry&&( <><div className="row px-md-5 mt-3 p-2">
  <div className="col-12 col-lg-3"></div>
  <div className="col-12 col-lg-6">
    <div className="p-0 m-0">
      {/* First Row */}
      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="labels">Die Name</label>
          <Input
            value={dieName}
            maxLength="250"
            onChange={(e) => setDieName(e.target.value)}
            placeholder="Enter Die Name"
            style={{ width: '100%' }}
          />
          {errors.dieName && <div className="errorField">{errors.dieName}</div>}
        </div>

        <div className="col-md-6 mb-3">
          <label className="labels">Dia Number</label>
          <Select
                                        value={diaNumber || undefined}
                                        onChange={setDiaNumber}
                                        showSearch
                                        className="w-100"
                                        placeholder="Select Dia Number"
                                        optionFilterProp="children"
                                       // mode='multiple'

                                      >
                                        {diaNumberOptions.map((opt) => (
                                          <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                          </Option>
                                        ))}
                                      </Select>
          {errors.diaNumber && <div className="errorField">{errors.diaNumber}</div>}
        </div>
      </div>

      {/* Second Row */}
      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="labels">Die Category</label>
          <Select
            value={dieCategory || undefined}
            onChange={handleDieCategoryChange}
            placeholder="Select Category"
            style={{ width: '100%' }}
            showSearch
                      optionFilterProp="children"
          >
            {allDieCategory.map((category) => (
              <Option key={category.id} value={category.id}>
                {category.dieCategoryName}
              </Option>
            ))}
          </Select>
          {errors.dieCategory && <div className="errorField">{errors.dieCategory}</div>}
        </div>

        <div className="col-md-6 mb-3">
          <label className="labels">Die Sub Category Name</label>
          <Select
            value={subDieCategory || undefined}
            onChange={(value) => setSubDieCategory(value)}
            placeholder="Select Sub Die Category"
            style={{ width: '100%' }}
            showSearch
                      optionFilterProp="children"
          >
            {allSubDieCategory.map((category) => (
              <Option key={category.id} value={category.id}>
                {category.dieSubCategoryName}
              </Option>
            ))}
          </Select>
          {errors.subDieCategory && <div className="errorField">{errors.subDieCategory}</div>}
        </div>
      </div>

      {/* Third Row */}
      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="labels">Type of Die</label>
          <Select
            value={dieType || undefined}
            onChange={(value) => setDieType(value)}
            placeholder="Enter Type of Die"
            style={{ width: '100%' }}
            showSearch
                      optionFilterProp="children"
          >
            <Option value="1">Hollow</Option>
            <Option value="2">Solid</Option>
          </Select>
          {errors.dieType && <div className="errorField">{errors.dieType}</div>}
        </div>

        <div className="col-md-6 mb-3">
          <label className="labels">Die Premium</label>
          <Input
            value={diePremium}
            maxLength="250"
            onChange={(e) => setDiePremium(e.target.value)}
            placeholder="Enter Die Premium"
            style={{ width: '100%' }}
          />
          {errors.diePremium && <div className="errorField">{errors.diePremium}</div>}
        </div>
      </div>

      {/* Fourth Row */}
      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="labels">Die Cost Collected</label>
          <Input
            value={costCollect}
            maxLength="250"
            onChange={(e) => setCostCollect(e.target.value)}
            placeholder="Enter Die Cost"
            style={{ width: '100%' }}
          />
          {errors.costCollect && <div className="errorField">{errors.costCollect}</div>}
        </div>

        <div className="col-md-6 mb-3">
          <label className="labels">Die Cost Refund Criteria</label>
          <Input
            value={costRefund}
            maxLength="250"
            onChange={(e) => setCostRefund(e.target.value)}
            placeholder="Enter Refund Criteria"
            style={{ width: '100%' }}
          />
          {errors.costRefund && <div className="errorField">{errors.costRefund}</div>}
        </div>
      </div>

      {/* Fifth Row */}
      <div className="row">
        <div className="col-md-10 mb-3">
          <label className="labels">HSN Code</label>
          <Select
            value={hsnCode || undefined}
            onChange={(value) => setHSNCode(value)}
            placeholder="Select HSN Code"
            style={{ width: '100%' }}
            showSearch
                      optionFilterProp="children"
          >
            {allHSN.map((c) => (
              <Option key={c.id} value={c.id}>
                {c.hsnCode}
              </Option>
            ))}
          </Select>
          {errors.hsnCode && <div className="errorField">{errors.hsnCode}</div>}
        </div>

      
      </div>

      {/* Sixth Row */}
      <div className="row">
      <div className="col-md-6 mb-3">
          <label className="labels">Whether Customer Made</label>
          <Select
            value={customerMade || undefined}
            onChange={(value) => setCustomerMade(value)}
            placeholder="Select Option"
            style={{ width: '100%' }}
            showSearch
                      optionFilterProp="children"
          >
            <Option value="1">Yes</Option>
            <Option value="2">No</Option>
          </Select>
          {errors.customerMade && <div className="errorField">{errors.customerMade}</div>}
        </div>
        <div className="col-md-6 mb-3">

          <label className="labels">Name of Customer</label>
          <Select
            value={customerName || undefined}
            onChange={(value) => setCustomerName(value)}
            placeholder="Select Customer"
            style={{ width: '100%' }}
            showSearch
                      optionFilterProp="children"
          >
            {allCustomer.map((c) => (
              <Option key={c.id} value={c.id}>
                {c.customerName}
              </Option>
            ))}
          </Select>
          {errors.customerName && <div className="errorField">{errors.customerName}</div>}
        </div>

      
      </div>

        
    
      <div className="col-12 py-1">
          <label className="labels">Remarks</label>
          <Input.TextArea
            value={remarks}
            maxLength="250"
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="Enter remarks"
            style={{ width: '100%' }}
          />
          {errors.remarks && <div className="errorField">{errors.remarks}</div>}
        </div>
        <div className="col-12 py-1">
          <label className="labels">Description</label>
          <Input.TextArea
            value={description}
            maxLength="250"
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter description"
            style={{ width: '100%' }}
          />
          {errors.description && <div className="errorField">{errors.description}</div>}
        </div>
      

      {/* Submit/Cancel Buttons */}
      <div className="col-12 text-center">
        <Button
          type="submit"
          className="CancelBtn mx-1"
          onClick={handleCancel}
        >
          Cancel
        </Button>
        {submitButton && (
          <Button
            type="submit"
            className="SubmitBtn mx-1"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        )}
        {updateButton && (
          <Button
            type="submit"
            className="UpdateBtn mx-1"
            onClick={handleUpdate}
          >
            Update
          </Button>
        )}
      </div>

    </div>
  </div>
</div>


        
          <div className="col-12 p-0 mt-3" style={{ borderBottom: "2px solid #bfb597" }}></div>
          </>
          )}
        
          {/*================ Table =========================*/}
       {showTable && (<>   <div className="row m-0 p-2  px-md-5 pt-md-0 mt-3">
            <div className="col-12 py-3 shadow border" style={{  backgroundColor: "white" }}>
              <div className="row ps-2 m-0 mb-2">
                                    <div className="col-12 col-md-3 col-lg-1">
                                      <Button
                                        onClick={handleShowForm}
                                        style={{ backgroundColor: '#f8bf28' }}
                                      >
                                        Add Die Name +
                                      </Button>
                                    </div>
                                    <div className="col-12 col-md-9 col-lg-11"></div>
                                  </div>
            
              <div className="col-12 px-md-5" style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                  <Select
                    defaultValue={pageSize}
                    onChange={handlePageSizeChange}
                    style={{ width: 120, textAlign: "center" }}
                  >
                    <Option value={10}>10</Option>
                    <Option value={20}>20</Option>
                    <Option value={30}>30</Option>
                  </Select>
                </div>
        
                <div className="pt-4 pt-md-0">
                  <Input.Search
                    placeholder="Search"
                onChange={(e) => handleSearch(e.target.value)}
                    style={{ width: 200, marginBottom: 16 }}
                  />
                </div>
              </div>
        
              <div style={{ backgroundColor: "white" }}>
                <Table
                  bordered
                  style={{ padding: "0px 20px", overflowX: "auto" }}
                  columns={columns}
                  dataSource={filteredData}
                  pagination={{
                    pageSize: pageSize,
                    total: totalEntries,
                    showTotal: (total, range) =>
                      `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                    current: currentPage,
                    onChange: (page) => setCurrentPage(page),
                  }}
                  showSorterTooltip={false}
                  rowKey={(record) => record.id}
                  components={components}
                />
              </div>
            </div>
          </div></>)}
        </div>
        </div>
        </div>
        </div>
        )
        
}

export default DieNameMaster